/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./project-demo-push-dialog.vue?vue&type=template&id=4af508e4&"
import script from "./project-demo-push-dialog.vue?vue&type=script&lang=ts&"
export * from "./project-demo-push-dialog.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports